<script setup lang="ts">
import { useItemStore } from "@/itemStore";
import type { Item } from "@/itemStore";

const itemStore = useItemStore();

const props = defineProps<{
  item: Item;
  nr: number;
}>();

const showDate = (date: string) => {
  const d = new Date(date);
  return d.toLocaleDateString(itemStore.lang);
};

const getClass = () => {
  let className = "tease";
  className += " tease-" + itemStore.type;
  Object.keys(props.item.terms).forEach((taxonomy) => {
    props.item.terms[taxonomy].forEach((term) => {
      className += ` tease-${taxonomy}-${term.slug}`;
    });
  });
  className += " tease-nr-" + props.nr;
  return className;
};

const getTerms = (taxonomy: string) => {
  let terms: string[];
  terms = [];
  props.item.terms[taxonomy].forEach((term) => {
    terms.push(term.name);
  });
  return terms.join(", ");
};

const getLink = (extra = true): string | undefined => {
  if (extra && itemStore.settings.hasLink && props.item.link) {
    return props.item.link;
  }
};

const getImageClass = () => {
  let className = "image-container";
  if (itemStore.settings.imagePostcard) {
    className += " postcard";
  }
  if (props.item.image.medium) {
    className += " has-image";
  } else {
    className += " placeholder";
  }
  return className;
};
</script>

<template>
  <article :class="getClass()" :id="'tease-' + item.id">
    <div :class="getImageClass()" v-if="itemStore.settings.showImage">
      <img v-if="item.image.large" :src="item.image.large" :alt="item.image.alt" />
    </div>
    <div class="data">
      <template v-for="key in itemStore.settings.showFields" :key="key">
        <div v-if="key === 'date'" class="post-date">
          {{ showDate(item.date) }}
        </div>
        <div v-else-if="item.data[key]" :class="'post-' + key">
          {{ item.data[key] }}
        </div>
        <div v-else-if="item.terms[key]" :class="'post-term post-term-' + key">
          {{ getTerms(key) }}
        </div>
      </template>
    </div>
    <div class="tease-content">
      <h3 class="post-title">
        <component :is="getLink() ? 'a' : 'span'" :href="getLink()">{{ item.title }}</component>
      </h3>
      <p class="preview" v-if="itemStore.settings.showPreview">{{ item.preview }}</p>
      <a
        :href="item.link"
        tabindex="-1"
        aria-hidden="true"
        class="tease-link btn-link"
        v-if="itemStore.settings.readMore && itemStore.settings.hasLink"
        >{{ itemStore.settings.readMore }}</a
      >
    </div>
  </article>
</template>
